//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { acquireAccessToken } from '../auth/authConfig';

export class BaseApiClient {
    transformOptions(options: RequestInit): Promise<RequestInit> {
        return new Promise((resolve, reject) => {
            acquireAccessToken()
                .then((response) => {
                    options.headers = {
                        ...options.headers,
                        Authorization: `Bearer ${response}`,
                    };
                    resolve(options);
                })
                .catch((error) => {
                    console.error('Failed to get access token', error);
                    reject(error);
                });
        });
    }
}

export interface ITimeTrackerApi {
    /**
     * @return Success
     */
    getCustomers(): Promise<Customer[]>;

    /**
     * @param body (optional)
     * @return Created
     */
    addCustomer(body?: Customer | undefined): Promise<Customer>;

    /**
     * @param body (optional)
     * @return Success
     */
    updateCustomer(body?: Customer | undefined): Promise<void>;

    /**
     * @return Success
     */
    getCustomerById(id: number): Promise<Customer>;

    /**
     * @return Success
     */
    deleteCustomer(id: number): Promise<void>;

    /**
     * @return Success
     */
    getCustomersByEmployee(id: number): Promise<Customer[]>;

    /**
     * @return Success
     */
    getCustomersByEmployeeAndDate(employeeId: number, date: Date): Promise<Customer[]>;

    /**
     * @return Success
     */
    getDashboard(accountingYear: number): Promise<Dashboard>;

    /**
     * @return Success
     */
    getEmployees(): Promise<Employee[]>;

    /**
     * @param body (optional)
     * @return Created
     */
    addEmployee(body?: Employee | undefined): Promise<Employee>;

    /**
     * @param body (optional)
     * @return Success
     */
    updateEmployee(body?: Employee | undefined): Promise<void>;

    /**
     * @return Success
     */
    getEmployeeById(id: number): Promise<Employee>;

    /**
     * @return Success
     */
    deleteEmployee(id: number): Promise<void>;

    /**
     * @return Success
     */
    getEmployeeByEmployeeNumber(emplNr: string): Promise<Employee[]>;

    /**
     * @return Success
     */
    getEmployeeByEmail(email: string): Promise<Employee>;

    /**
     * @return Success
     */
    getEmployeeDashboard(emplNr: string, accountingYear: number): Promise<Employee>;

    /**
     * @return Success
     */
    getProjects(): Promise<Project[]>;

    /**
     * @param body (optional)
     * @return Created
     */
    addProject(body?: Project | undefined): Promise<Project>;

    /**
     * @param body (optional)
     * @return Success
     */
    updateProject(body?: Project | undefined): Promise<void>;

    /**
     * @return Success
     */
    getProjectById(id: number): Promise<Project>;

    /**
     * @return Success
     */
    deleteProject(id: number): Promise<void>;

    /**
     * @return Success
     */
    getStaffings(): Promise<Staffing[]>;

    /**
     * @param body (optional)
     * @return Created
     */
    addStaffing(body?: Staffing | undefined): Promise<Staffing>;

    /**
     * @param body (optional)
     * @return Success
     */
    updateStaffing(body?: Staffing | undefined): Promise<void>;

    /**
     * @return Success
     */
    getStaffingById(id: number): Promise<Staffing>;

    /**
     * @return Success
     */
    deleteStaffing(id: number): Promise<void>;

    /**
     * @param json (optional)
     * @return Success
     */
    getStaffingsByFilter(json?: string | undefined): Promise<Staffing[]>;

    /**
     * @return Success
     */
    getTasks(): Promise<Task[]>;

    /**
     * @param body (optional)
     * @return Created
     */
    addTask(body?: Task | undefined): Promise<Task>;

    /**
     * @param body (optional)
     * @return Success
     */
    updateTask(body?: Task | undefined): Promise<void>;

    /**
     * @return Success
     */
    getTaskById(id: number): Promise<Task>;

    /**
     * @return Success
     */
    deleteTask(id: number): Promise<void>;

    /**
     * @return Success
     */
    getTime(): Promise<TimeEntry[]>;

    /**
     * @param body (optional)
     * @return Created
     */
    addTimeEntry(body?: TimeEntry | undefined): Promise<TimeEntry>;

    /**
     * @param body (optional)
     * @return Success
     */
    updateTimeEntry(body?: TimeEntry | undefined): Promise<void>;

    /**
     * @return Success
     */
    getTimeById(id: number): Promise<void>;

    /**
     * @return Success
     */
    deleteTimeEntry(id: number): Promise<void>;

    /**
     * @param json (optional)
     * @return Success
     */
    getTimeByFilter(json?: string | undefined): Promise<TimeEntry[]>;
}

export class TimeTrackerApi extends BaseApiClient implements ITimeTrackerApi {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : (window as any);
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    }

    /**
     * @return Success
     */
    getCustomers(): Promise<Customer[]> {
        let url_ = this.baseUrl + '/api/customers';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetCustomers(_response);
            });
    }

    protected processGetCustomers(response: Response): Promise<Customer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Customer[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Created
     */
    addCustomer(body?: Customer | undefined): Promise<Customer> {
        let url_ = this.baseUrl + '/api/customers';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'text/plain',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processAddCustomer(_response);
            });
    }

    protected processAddCustomer(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Customer);
                return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateCustomer(body?: Customer | undefined): Promise<void> {
        let url_ = this.baseUrl + '/api/customers';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processUpdateCustomer(_response);
            });
    }

    protected processUpdateCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCustomerById(id: number): Promise<Customer> {
        let url_ = this.baseUrl + '/api/customers/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetCustomerById(_response);
            });
    }

    protected processGetCustomerById(response: Response): Promise<Customer> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Customer);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer>(null as any);
    }

    /**
     * @return Success
     */
    deleteCustomer(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/customers/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processDeleteCustomer(_response);
            });
    }

    protected processDeleteCustomer(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getCustomersByEmployee(id: number): Promise<Customer[]> {
        let url_ = this.baseUrl + '/api/customers/empl/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetCustomersByEmployee(_response);
            });
    }

    protected processGetCustomersByEmployee(response: Response): Promise<Customer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Customer[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer[]>(null as any);
    }

    /**
     * @return Success
     */
    getCustomersByEmployeeAndDate(employeeId: number, date: Date): Promise<Customer[]> {
        let url_ = this.baseUrl + '/api/customers/empl-date/{employeeId}/{date}';
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace('{employeeId}', encodeURIComponent('' + employeeId));
        if (date === undefined || date === null) throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace('{date}', encodeURIComponent(date ? '' + date.toISOString() : 'null'));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetCustomersByEmployeeAndDate(_response);
            });
    }

    protected processGetCustomersByEmployeeAndDate(response: Response): Promise<Customer[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Customer[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Customer[]>(null as any);
    }

    /**
     * @return Success
     */
    getDashboard(accountingYear: number): Promise<Dashboard> {
        let url_ = this.baseUrl + '/api/dashboard/{accountingYear}';
        if (accountingYear === undefined || accountingYear === null)
            throw new Error("The parameter 'accountingYear' must be defined.");
        url_ = url_.replace('{accountingYear}', encodeURIComponent('' + accountingYear));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetDashboard(_response);
            });
    }

    protected processGetDashboard(response: Response): Promise<Dashboard> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Dashboard);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Dashboard>(null as any);
    }

    /**
     * @return Success
     */
    getEmployees(): Promise<Employee[]> {
        let url_ = this.baseUrl + '/api/employees';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetEmployees(_response);
            });
    }

    protected processGetEmployees(response: Response): Promise<Employee[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Employee[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Created
     */
    addEmployee(body?: Employee | undefined): Promise<Employee> {
        let url_ = this.baseUrl + '/api/employees';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processAddEmployee(_response);
            });
    }

    protected processAddEmployee(response: Response): Promise<Employee> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Employee);
                return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateEmployee(body?: Employee | undefined): Promise<void> {
        let url_ = this.baseUrl + '/api/employees';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processUpdateEmployee(_response);
            });
    }

    protected processUpdateEmployee(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeById(id: number): Promise<Employee> {
        let url_ = this.baseUrl + '/api/employees/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetEmployeeById(_response);
            });
    }

    protected processGetEmployeeById(response: Response): Promise<Employee> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Employee);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee>(null as any);
    }

    /**
     * @return Success
     */
    deleteEmployee(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/employees/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processDeleteEmployee(_response);
            });
    }

    protected processDeleteEmployee(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeByEmployeeNumber(emplNr: string): Promise<Employee[]> {
        let url_ = this.baseUrl + '/api/employees/emplNr/{emplNr}';
        if (emplNr === undefined || emplNr === null) throw new Error("The parameter 'emplNr' must be defined.");
        url_ = url_.replace('{emplNr}', encodeURIComponent('' + emplNr));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetEmployeeByEmployeeNumber(_response);
            });
    }

    protected processGetEmployeeByEmployeeNumber(response: Response): Promise<Employee[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Employee[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee[]>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeByEmail(email: string): Promise<Employee> {
        let url_ = this.baseUrl + '/api/employees/email/{email}';
        if (email === undefined || email === null) throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace('{email}', encodeURIComponent('' + email));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetEmployeeByEmail(_response);
            });
    }

    protected processGetEmployeeByEmail(response: Response): Promise<Employee> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Employee);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee>(null as any);
    }

    /**
     * @return Success
     */
    getEmployeeDashboard(emplNr: string, accountingYear: number): Promise<Employee> {
        let url_ = this.baseUrl + '/api/employees/dashboard/{emplNr}/{accountingYear}';
        if (emplNr === undefined || emplNr === null) throw new Error("The parameter 'emplNr' must be defined.");
        url_ = url_.replace('{emplNr}', encodeURIComponent('' + emplNr));
        if (accountingYear === undefined || accountingYear === null)
            throw new Error("The parameter 'accountingYear' must be defined.");
        url_ = url_.replace('{accountingYear}', encodeURIComponent('' + accountingYear));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetEmployeeDashboard(_response);
            });
    }

    protected processGetEmployeeDashboard(response: Response): Promise<Employee> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Employee);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Employee>(null as any);
    }

    /**
     * @return Success
     */
    getProjects(): Promise<Project[]> {
        let url_ = this.baseUrl + '/api/projects';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetProjects(_response);
            });
    }

    protected processGetProjects(response: Response): Promise<Project[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Project[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Project[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Created
     */
    addProject(body?: Project | undefined): Promise<Project> {
        let url_ = this.baseUrl + '/api/projects';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processAddProject(_response);
            });
    }

    protected processAddProject(response: Response): Promise<Project> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Project);
                return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Project>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateProject(body?: Project | undefined): Promise<void> {
        let url_ = this.baseUrl + '/api/projects';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processUpdateProject(_response);
            });
    }

    protected processUpdateProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getProjectById(id: number): Promise<Project> {
        let url_ = this.baseUrl + '/api/projects/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetProjectById(_response);
            });
    }

    protected processGetProjectById(response: Response): Promise<Project> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Project);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Project>(null as any);
    }

    /**
     * @return Success
     */
    deleteProject(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/projects/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processDeleteProject(_response);
            });
    }

    protected processDeleteProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStaffings(): Promise<Staffing[]> {
        let url_ = this.baseUrl + '/api/staffings';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetStaffings(_response);
            });
    }

    protected processGetStaffings(response: Response): Promise<Staffing[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Staffing[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Staffing[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Created
     */
    addStaffing(body?: Staffing | undefined): Promise<Staffing> {
        let url_ = this.baseUrl + '/api/staffings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processAddStaffing(_response);
            });
    }

    protected processAddStaffing(response: Response): Promise<Staffing> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Staffing);
                return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Staffing>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateStaffing(body?: Staffing | undefined): Promise<void> {
        let url_ = this.baseUrl + '/api/staffings';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processUpdateStaffing(_response);
            });
    }

    protected processUpdateStaffing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getStaffingById(id: number): Promise<Staffing> {
        let url_ = this.baseUrl + '/api/staffings/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetStaffingById(_response);
            });
    }

    protected processGetStaffingById(response: Response): Promise<Staffing> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Staffing);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Staffing>(null as any);
    }

    /**
     * @return Success
     */
    deleteStaffing(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/staffings/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processDeleteStaffing(_response);
            });
    }

    protected processDeleteStaffing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param json (optional)
     * @return Success
     */
    getStaffingsByFilter(json?: string | undefined): Promise<Staffing[]> {
        let url_ = this.baseUrl + '/api/staffings/filter?';
        if (json === null) throw new Error("The parameter 'json' cannot be null.");
        else if (json !== undefined) url_ += 'json=' + encodeURIComponent('' + json) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetStaffingsByFilter(_response);
            });
    }

    protected processGetStaffingsByFilter(response: Response): Promise<Staffing[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Staffing[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Staffing[]>(null as any);
    }

    /**
     * @return Success
     */
    getTasks(): Promise<Task[]> {
        let url_ = this.baseUrl + '/api/tasks';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetTasks(_response);
            });
    }

    protected processGetTasks(response: Response): Promise<Task[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Task[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Task[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Created
     */
    addTask(body?: Task | undefined): Promise<Task> {
        let url_ = this.baseUrl + '/api/tasks';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processAddTask(_response);
            });
    }

    protected processAddTask(response: Response): Promise<Task> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Task);
                return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Task>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateTask(body?: Task | undefined): Promise<void> {
        let url_ = this.baseUrl + '/api/tasks';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processUpdateTask(_response);
            });
    }

    protected processUpdateTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTaskById(id: number): Promise<Task> {
        let url_ = this.baseUrl + '/api/tasks/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetTaskById(_response);
            });
    }

    protected processGetTaskById(response: Response): Promise<Task> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 = _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as Task);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<Task>(null as any);
    }

    /**
     * @return Success
     */
    deleteTask(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/tasks/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processDeleteTask(_response);
            });
    }

    protected processDeleteTask(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTime(): Promise<TimeEntry[]> {
        let url_ = this.baseUrl + '/api/time';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetTime(_response);
            });
    }

    protected processGetTime(response: Response): Promise<TimeEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeEntry[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeEntry[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Created
     */
    addTimeEntry(body?: TimeEntry | undefined): Promise<TimeEntry> {
        let url_ = this.baseUrl + '/api/time';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processAddTimeEntry(_response);
            });
    }

    protected processAddTimeEntry(response: Response): Promise<TimeEntry> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 201) {
            return response.text().then((_responseText) => {
                let result201: any = null;
                result201 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeEntry);
                return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeEntry>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateTimeEntry(body?: TimeEntry | undefined): Promise<void> {
        let url_ = this.baseUrl + '/api/time';
        url_ = url_.replace(/[?&]$/, '');

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processUpdateTimeEntry(_response);
            });
    }

    protected processUpdateTimeEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getTimeById(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/time/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {},
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetTimeById(_response);
            });
    }

    protected processGetTimeById(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    deleteTimeEntry(id: number): Promise<void> {
        let url_ = this.baseUrl + '/api/time/{id}';
        if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace('{id}', encodeURIComponent('' + id));
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'DELETE',
            headers: {},
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processDeleteTimeEntry(_response);
            });
    }

    protected processDeleteTimeEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param json (optional)
     * @return Success
     */
    getTimeByFilter(json?: string | undefined): Promise<TimeEntry[]> {
        let url_ = this.baseUrl + '/api/time/filter?';
        if (json === null) throw new Error("The parameter 'json' cannot be null.");
        else if (json !== undefined) url_ += 'json=' + encodeURIComponent('' + json) + '&';
        url_ = url_.replace(/[?&]$/, '');

        let options_: RequestInit = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };

        return this.transformOptions(options_)
            .then((transformedOptions_) => {
                return this.http.fetch(url_, transformedOptions_);
            })
            .then((_response: Response) => {
                return this.processGetTimeByFilter(_response);
            });
    }

    protected processGetTimeByFilter(response: Response): Promise<TimeEntry[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v: any, k: any) => (_headers[k] = v));
        }
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200: any = null;
                result200 =
                    _responseText === '' ? null : (JSON.parse(_responseText, this.jsonParseReviver) as TimeEntry[]);
                return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException('An unexpected server error occurred.', status, _responseText, _headers);
            });
        }
        return Promise.resolve<TimeEntry[]>(null as any);
    }
}

export interface Customer {
    id?: number;
    rowStartDate?: Date;
    rowEndDate?: Date | undefined;
    rowIsActive?: boolean;
    name?: string | undefined;
    projects?: Project[] | undefined;
}

export interface Dashboard {
    totalHours?: number;
    chargeability?: number;
    totalSales?: number;
    salesData?: SalesYTD[] | undefined;
}

export interface Employee {
    id?: number;
    rowStartDate?: Date;
    rowEndDate?: Date | undefined;
    rowIsActive?: boolean;
    email: string;
    firstName: string;
    lastName: string;
    employeeNumber?: string | undefined;
    defaultRate?: number;
    manager?: Employee;
    hireDate?: Date | undefined;
    careerPath?: string | undefined;
    profile?: string | undefined;
    staffings?: Staffing[] | undefined;
    totalHours?: number;
    chargeability?: number;
    totalSales?: number;
    readonly fullName?: string | undefined;
}

export interface Project {
    id?: number;
    rowStartDate?: Date;
    rowEndDate?: Date | undefined;
    rowIsActive?: boolean;
    name?: string | undefined;
    tasks?: Task[] | undefined;
    customer_Id: number;
    customer?: Customer;
}

export interface SalesYTD {
    year?: number;
    sales?: number[] | undefined;
}

export interface Staffing {
    id?: number;
    rowStartDate?: Date;
    rowEndDate?: Date | undefined;
    rowIsActive?: boolean;
    task_Id: number;
    task?: Task;
    employee_Id: number;
    employee?: Employee;
    timeEntries?: TimeEntry[] | undefined;
    startDate?: Date;
    endDate?: Date | undefined;
    rate?: number;
    readonly isOngoing?: boolean;
}

export interface Task {
    id?: number;
    rowStartDate?: Date;
    rowEndDate?: Date | undefined;
    rowIsActive?: boolean;
    name?: string | undefined;
    project_Id: number;
    project?: Project;
    staffings?: Staffing[] | undefined;
}

export interface TimeEntry {
    id?: number;
    rowStartDate?: Date;
    rowEndDate?: Date | undefined;
    rowIsActive?: boolean;
    date?: Date;
    description?: string | undefined;
    quantity?: number;
    isOvertime?: boolean;
    staffing_Id: number;
    staffing?: Staffing;
    readonly weekOfYear?: number;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any
): any {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
}
